














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

Vue.component("BaseButton", BaseButton);
Vue.component("BaseIcon", BaseIcon);
@Component({ name: "PreviewSetButton" })
export default class PreviewSetButton extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly public!: boolean;

  @Prop({ type: Object, default: () => ({ width: "max(min(6vw, 40px), 28px)", height: "max(min(6vw, 40px), 28px)" }) })
  public readonly wrapperStyle!: Record<string, string>;

  @Prop({ type: String, default: "max(min(3vw,20px), 13px)" })
  public readonly iconSize!: string;
}
